import { lget, lsend, istHomescreenApp } from "@/portal/listenApi";

/* Web-Push für Listen: Opt-in erst nach Klick, Abo je Gerät, Einstellung je Liste. Keine Schlüssel im Bundle – der öffentliche VAPID-Schlüssel kommt vom Server. */
const SCOPE = "/l";
const b64 = (s) => { const p = "=".repeat((4 - (s.length % 4)) % 4); const r = window.atob((s + p).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...r].map((c) => c.charCodeAt(0))); };

export const pushUnterstuetzt = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const istIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const iosOhneHomescreen = () => istIOS() && !istHomescreenApp();
export const berechtigung = () => ("Notification" in window ? window.Notification.permission : "unsupported");

export const swRegistrieren = async () => { if (!("serviceWorker" in navigator)) return null; try { return await navigator.serviceWorker.register("/listen-sw.js", { scope: SCOPE }); } catch { return null; } };
export const aktuellesAbo = async () => { if (!pushUnterstuetzt()) return null; const reg = await navigator.serviceWorker.getRegistration(SCOPE); return reg ? reg.pushManager.getSubscription() : null; };

export const abonnieren = async (lid, einstellung = "alle") => {
  const v = await lget("/listen/push/vapid");
  if (!v.verfuegbar) throw new Error("Push ist auf dem Server noch nicht eingerichtet.");
  const reg = await swRegistrieren();
  if (!reg) throw new Error("Service Worker konnte nicht registriert werden.");
  await navigator.serviceWorker.ready;
  const perm = await window.Notification.requestPermission();
  if (perm !== "granted") throw Object.assign(new Error("Benachrichtigungen wurden nicht erlaubt."), { abgelehnt: true });
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64(v.public_key) });
  await lsend("POST", `/listen/${lid}/push/abo`, { subscription: sub.toJSON(), einstellung, ua: navigator.userAgent.slice(0, 200) }, lid);
  return sub;
};

export const einstellungSetzen = async (lid, einstellung) => {
  const sub = await aktuellesAbo();
  if (!sub) throw new Error("Auf diesem Gerät ist kein Push-Abo aktiv.");
  return lsend("PUT", `/listen/${lid}/push/einstellung`, { endpoint: sub.endpoint, einstellung }, lid);
};

export const abmelden = async () => {
  const sub = await aktuellesAbo();
  if (!sub) return;
  await lsend("DELETE", "/listen/push/abo", { endpoint: sub.endpoint });
  await sub.unsubscribe();
};

export const status = async (lid) => {
  const sub = await aktuellesAbo();
  return lget(`/listen/${lid}/push/status${sub ? `?endpoint=${encodeURIComponent(sub.endpoint)}` : ""}`, lid);
};

export const badgeSetzen = (n) => { try { if (navigator.setAppBadge) (n > 0 ? navigator.setAppBadge(n) : navigator.clearAppBadge()).catch(() => {}); } catch { /* nicht unterstützt */ } };
export const gelesenMelden = (lid) => lsend("POST", `/listen/${lid}/gelesen`, {}, lid).catch(() => {});
